import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-inner-card-group',
  templateUrl: './inner-card-group.component.html',
  styleUrls: ['./inner-card-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InnerCardGroupComponent {
  @Input() isTransparent: boolean;
  // Stretch inner cards to full width
  @Input() isFullWidth: boolean;
}
